import type { ColumnHelper } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { type TFunction } from 'i18next';

import type { BrandsTable } from '../../../types';
import { BrandImage } from '../../images/BrandImage';
import DTBoldCell from '../DTBoldCell';
import { DTCell } from '../DTCell';
import DTHeader from '../DTHeader';

type GetProspectsTableHeadersProps = {
  columnHelper: ColumnHelper<BrandsTable>;
  handleChangeSortDirection: (id: string) => void;
  t: TFunction;
  extras: {};
};

export const getProspectsTableHeaders = ({
  columnHelper,
  handleChangeSortDirection,
  t,
}: GetProspectsTableHeadersProps) => [
  columnHelper.accessor('name', {
    size: 150,
    minSize: 150,
    maxSize: 200,
    cell: (info) => {
      return (
        <DTBoldCell
          content={info.getValue()}
          id={info.cell.id}
          image={
            <BrandImage
              size="size-[38px]"
              image={info.row.original.profile_picture}
            />
          }
        />
      );
    },
    header: ({ header, ...info }) => {
      return (
        <DTHeader
          sortable
          first
          onClick={() => handleChangeSortDirection(header.id)}
          title={t('prospects.header1')}
          sorting={(info as any).orderBy}
          sortingDirection={(info as any).orderDirection}
          accessor="name"
        />
      );
    },
  }),
  columnHelper.accessor('campaignCount', {
    size: 150,
    minSize: 150,
    maxSize: 200,
    header: () => (
      <DTHeader
        onClick={() => {}}
        title={t('prospects.header2')}
        accessor="campaignCount"
      />
    ),
    cell: (info) => (
      <DTCell
        text={`${info?.getValue()?.toString() || 0} ${info?.getValue() !== 1 ? t('brands.columnCampaignsTextPlural') : t('brands.columnCampaignsTextSingular')}`}
      />
    ),
  }),
  columnHelper.accessor('createdAt', {
    size: 150,
    minSize: 150,
    maxSize: 200,
    header: ({ header, ...info }) => (
      <DTHeader
        sortable
        onClick={() => handleChangeSortDirection(header.id)}
        title={t('prospects.header3')}
        sorting={(info as any).orderBy}
        sortingDirection={(info as any).orderDirection}
        accessor="createdAt"
        last
      />
    ),
    cell: (info) => (
      <DTCell
        text={
          info.getValue()
            ? dayjs(new Date(parseInt(info.getValue(), 10))).format(
                'DD-MM-YYYY',
              )
            : ''
        }
      />
    ),
  }),
];
